<div class="toast-container">
  <app-toast-notification
    *ngFor="let toast of toasts$ | async; trackBy: trackById"
    [message]="toast.message"
    [type]="toast.type"
    (closed)="dismiss(toast.id)"
  ></app-toast-notification>
</div>
